// frontend/src/components/reputation/GmbCommandModal.jsx
// Version: 2.0 (quick-260916-wll — отказ меняет вид экрана)
// Description: Пульт управления Google Business Profile: 7-факторный аудит,
//              генератор и публикатор постов, ответы на отзывы, каталог услуг
//              и настройки автопилота.
//
// 🔴 ЧТО УБРАНО 17.09.2026. В `catch` загрузки стоял блок подстановки: когда
//    ручка ОТКАЗЫВАЛА, экран рисовал правдоподобную картину — просмотры,
//    поиски, звонки, оценку аудита, четыре услуги и отметку «синхронизировано
//    только что» РОВНО В МОМЕНТ ОТКАЗА. Отказ уходил в `console.warn`, то есть
//    человеку не показывался вообще. Кнопки «Sync Now» и «Re-Run Audit» в
//    `catch` печатали ЗЕЛЁНЫЙ УСПЕХ: «Sync complete», «Audit updated».
//
// 🔴 ПРОВЕРКА СЕБЯ, КОТОРУЮ ЗДЕСЬ НАДО ДЕРЖАТЬ: «если источник не ответит,
//    экран станет выглядеть иначе?» Не станет — правка не сделана.
//
// 🔴 НОЛЬ И «НЕ ИЗМЕРЕНО» — РАЗНЫЕ СОСТОЯНИЯ МИРА. Печатать величины только
//    через `pokazatVelichinu`: запись `{v || '—'}` превратила бы измеренный
//    ноль звонков в прочерк, то есть в «не измеряли».
//
// 🔴 ЧЕГО ЭТОТ ЭКРАН НЕ ЗНАЕТ: истинности чисел, которые отдала ручка. Две
//    существующие боевые строки `gmb_locations` до сих пор содержат выдумку
//    (скрипт сброса НЕ ЗАПУСКАЛСЯ), и экран честно покажет ИХ содержимое.
//
// 🔴 ЧТО ЗАПРЕЩЕНО ЗДЕСЬ С 17.09.2026 (quick-260917-06b):
//    · КЛИК, ПОРОЖДАЮЩИЙ ЛОЖНОЕ ОЖИДАНИЕ. Кнопка «Sync Now» нажималась
//      всегда, а ручка за ней ставила «синхронизировано» с Google, ничего у
//      Google не спросив. Теперь кнопка ВЫКЛЮЧЕНА, пока Google не подключён
//      или запись в состоянии NOT_CONNECTED, и подсказка называет причину.
//    · КЛИК, ПОРОЖДАЮЩИЙ ПУСТОЙ ЗАПРОС: обращение «на всякий случай» само по
//      себе создаёт у человека ожидание ответа Google.
//    · ТОСТ, УТВЕРЖДАЮЩИЙ СИНХРОНИЗАЦИЮ, КОГДА ОБМЕНА НЕ БЫЛО. Успех
//      печатается ТОЛЬКО при `result.status === 'synced'`.
// 🔴 ЧТО ЗАПРЕЩЕНО ЗДЕСЬ С 17.09.2026 ДОПОЛНИТЕЛЬНО (quick-260917-23g):
//    · ПЕРЕСОБИРАТЬ ПРАВИЛО ГОТОВНОСТИ. Готовность к синхронизации решает
//      СЕРВЕР и присылает готовым признаком `can_sync`; его держатель —
//      `gmb_service.pravilo_gotovnosti_k_sync`. Писать здесь
//      `connected && has_gmb_scope` (или любую часть этого условия как рубеж
//      перед действием) нельзя: копий правила станет больше, а разошлись уже
//      имевшиеся две.
//    · ЧИТАТЬ «ПОЛЯ НЕТ» КАК «МОЖНО». Сравнение строго с `true`: ответ старой
//      формы, отказ ручки и неприход ответа обязаны ВЫКЛЮЧАТЬ кнопку.
//      Незнание не равно разрешению.
//    · СКЛЕИВАТЬ ПОДСКАЗКИ «нет аккаунта» и «нет прав Business Profile»: это
//      разные работы человека, и общий текст отправляет его не туда.
// 🔴 ПРОВЕРКА СЕБЯ ДЛЯ ЭТОГО ЭКРАНА: «если Google не подключён, отличается ли
//    экран от подключённого?» Не отличается — правка не сделана.

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import {
  X,
  Sparkles,
  RefreshCw,
  Send,
  CheckCircle2,
  AlertTriangle,
  ExternalLink,
  MapPin,
  Calendar,
  MessageSquare,
  Briefcase,
  Sliders,
  ShieldCheck,
  TrendingUp,
  Clock,
  Eye,
  PhoneCall,
  Search,
  Check,
  FileText,
  Bot,
  Copy,
  Camera,
  Image as ImageIcon,
  Upload,
  Trash2,
  CheckSquare
} from 'lucide-react';

/**
 * 🔴 ЕДИНСТВЕННЫЙ СПОСОБ НАПЕЧАТАТЬ ВЕЛИЧИНУ. `null`/`undefined` — «не
 * измеряли», прочерк; ноль — ОТВЕТ и печатается нулём. Запись `{v || '—'}`
 * здесь запрещена: ноль в JS ложен, и измеренный ноль звонков напечатался бы
 * как «не измерено».
 */
export const pokazatVelichinu = (v) => (v === null || v === undefined ? '—' : String(v));

/**
 * Плашка состояния записи. 🔴 `sync_status` во фронте НЕ ПОКАЗЫВАЛСЯ НИГДЕ
 * (`grep -rn "sync_status" frontend/src` до правки — пусто), то есть
 * «подключено ли» человек узнать не мог.
 * Четыре состояния, и они РАЗНЫЕ: отказ запроса ≠ не подключено ≠ ошибка
 * синхронизации ≠ синхронизировано.
 */
const NE_PODKLYUCHEN = 'Google Business Profile не подключён. Данные о просмотрах и звонках станут доступны после авторизации в Google My Business.';

export const PlashkaSostoyaniya = ({ otkazZagruzki, location }) => {
  if (otkazZagruzki) {
    return (
      <div data-plashka="otkaz" className="p-4 rounded-xl border bg-[#FBEAEA] border-[#E5B5B5] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">Состояние записи НЕИЗВЕСТНО: спросить не удалось.</span>
        <p className="mt-0.5 text-[#687077]">Причина отказа: {otkazZagruzki}. Ни одно число ниже не подставлено вместо ответа — их просто нет. {NE_PODKLYUCHEN}</p>
      </div>
    );
  }
  if (!location) {
    return (
      <div data-plashka="net-otveta" className="p-4 rounded-xl border bg-[#F8F7F2] border-[#E5E1D6] text-xs leading-relaxed text-[#687077]">
        Ответ ручки ещё не получен: состояние записи не показывается, потому что оно неизвестно.
      </div>
    );
  }
  if (location.sync_status === 'error') {
    return (
      <div data-plashka="oshibka" className="p-4 rounded-xl border bg-[#FBEAEA] border-[#E5B5B5] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">Последняя синхронизация завершилась ошибкой.</span>
        <p className="mt-0.5 text-[#687077]">{location.sync_error || 'причина не названа'}</p>
      </div>
    );
  }
  if (location.sync_status === 'synced') {
    return (
      <div data-plashka="synced" className="p-4 rounded-xl border bg-[#E6F6EE] border-[#B7E5D0] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">Запись синхронизирована.</span>
        <p className="mt-0.5 text-[#687077]">
          Момент синхронизации (по серверу): {location.last_synced_at ? location.last_synced_at : 'синхронизации не было'}
        </p>
      </div>
    );
  }
  if (location.sync_status === 'NOT_CONNECTED') {
    return (
      <div data-plashka="ne-podklyuchen" className="p-4 rounded-xl border bg-[#FAF4E5] border-[#E5D7B5] text-xs leading-relaxed text-[#20231F]">
        <span className="font-bold">{NE_PODKLYUCHEN}</span>
        <p className="mt-0.5 text-[#687077]">Состояние записи: NOT_CONNECTED.</p>
      </div>
    );
  }
  // 🔴 Значение статуса вне закрытого перечня (NOT_CONNECTED, synced, pending,
  //    error) — это НЕ «не подключён» и не «синхронизировано»: неизвестное
  //    называется неизвестным, а не приводится к ближайшему знакомому.
  return (
    <div data-plashka="neopoznan" className="p-4 rounded-xl border bg-[#F8F7F2] border-[#E5E1D6] text-xs leading-relaxed text-[#20231F]">
      <span className="font-bold">Состояние записи не опознано: {pokazatVelichinu(location.sync_status)}.</span>
      <p className="mt-0.5 text-[#687077]">Известные значения: NOT_CONNECTED, synced, pending, error.</p>
    </div>
  );
};

/**
 * Показатели за 30 дней. 🔴 Их на этом экране НЕ БЫЛО ВООБЩЕ: ручка их отдавала,
 * а пульт показывал только в подстановке при отказе — то есть человек видел
 * числа РОВНО ТОГДА, когда их не было. Теперь наоборот.
 */
const POKAZATELI = [
  ['views_30d', 'Просмотры'],
  ['searches_30d', 'Поиски'],
  ['calls_30d', 'Звонки'],
  ['website_clicks_30d', 'Переходы на сайт'],
  ['directions_30d', 'Маршруты'],
];

export const GmbCommandModal = ({ isOpen, onClose, office }) => {
  const [activeTab, setActiveTab] = useState('audit'); // 'audit', 'posts', 'reviews', 'services', 'autopilot'
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [auditing, setAuditing] = useState(false);
  const [generatingPost, setGeneratingPost] = useState(false);
  // Attorney Photo Media Vault state
  const [availablePhotos, setAvailablePhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [photoCategory, setPhotoCategory] = useState('all');
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [showPhotoVault, setShowPhotoVault] = useState(false);
  const [publishingPost, setPublishingPost] = useState(false);
  
  // Data state
  const [locationData, setLocationData] = useState(null);
  // 🔴 Отказ загрузки — ТРЕТЬЕ состояние, а не «данных нет»: «не смогли
  //    спросить» и «спросили, ответили пусто» выглядят на экране по-разному.
  const [otkazZagruzki, setOtkazZagruzki] = useState(null);
  const [posts, setPosts] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [latestAudit, setLatestAudit] = useState(null);

  // Post form state
  const [postTopic, setPostTopic] = useState('');
  const [postSummary, setPostSummary] = useState('');
  const [postCtaType, setPostCtaType] = useState('BOOK');
  const [postCtaUrl, setPostCtaUrl] = useState('https://fitenkolaw.com/consultation');

  // Review reply state
  const [replyingReviewId, setReplyingReviewId] = useState(null);
  const [replyDrafts, setReplyDrafts] = useState({});
  const [submittingReply, setSubmittingReply] = useState(false);

  // Autopilot settings state
  const [autopilotEnabled, setAutopilotEnabled] = useState(true);
  const [autopilotWeeklyPost, setAutopilotWeeklyPost] = useState(true);
  const [autopilotReviewReply, setAutopilotReviewReply] = useState(true);
  const [autopilotPostDay, setAutopilotPostDay] = useState('Monday');

  // Google OAuth status
  // 🔴 `can_sync: false` в начальном состоянии: ДО ответа ручки экран обязан
  //    вести себя как «нельзя». Отсутствие признака — не разрешение.
  const [authStatus, setAuthStatus] = useState({ connected: false, has_gmb_scope: false, email: '', can_sync: false });
  const [connectingGoogle, setConnectingGoogle] = useState(false);

  const fetchAttorneyPhotos = async () => {
    try {
      const res = await axios.get('/api/v1/reputation/gmb/media/photos');
      if (res.data?.photos) {
        setAvailablePhotos(res.data.photos);
        if (!selectedPhoto && res.data.photos.length > 0) {
          const defaultPhoto = res.data.photos.find(p => p.category === 'portrait' || p.category === 'action') || res.data.photos[0];
          setSelectedPhoto(defaultPhoto);
        }
      }
    } catch (err) {
      console.error('Failed to fetch attorney photos', err);
    }
  };

  const handleBulkUploadPhotos = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    if (files.length > 50) {
      toast.error('You can upload up to 50 photos at a time.');
      return;
    }
    setUploadingPhotos(true);
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    try {
      const res = await axios.post('/api/v1/reputation/gmb/media/photos/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data?.success) {
        toast.success(`Успешно загружено ${res.data.uploaded_count} фото адвоката в медиа-хранилище!`);
        await fetchAttorneyPhotos();
      }
    } catch (err) {
      toast.error('Ошибка при загрузке фото');
    } finally {
      setUploadingPhotos(false);
      if (e.target) e.target.value = '';
    }
  };

    const profileId = office?.id;

  // Load dashboard data on open
  useEffect(() => {
    if (!isOpen || !profileId) return;

fetchAttorneyPhotos();
    const fetchGmbData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`/api/v1/reputation/gmb/locations/${profileId}`);
        setOtkazZagruzki(null);
        if (res.data) {
          setLocationData(res.data.location);
          setPosts(res.data.posts || []);
          setReviews(res.data.reviews || []);
          setLatestAudit(res.data.latest_audit);
          if (res.data.location) {
            setAutopilotEnabled(res.data.location.autopilot_enabled);
            setAutopilotWeeklyPost(res.data.location.autopilot_weekly_post);
            setAutopilotReviewReply(res.data.location.autopilot_review_auto_reply);
            setAutopilotPostDay(res.data.location.autopilot_post_day || 'Monday');
          }
        }
      } catch (err) {
        // 🔴 НИ ОДНОЙ ПОДСТАНОВКИ. Ручка не ответила — значит мы не знаем
        //    ничего, и экран обязан выглядеть ИНАЧЕ, а не правдоподобно.
        console.warn('GMB: запрос состояния отказал:', err);
        setLocationData(null);
        setLatestAudit(null);
        setPosts([]);
        setReviews([]);
        setOtkazZagruzki((err && err.message) || 'причина не названа');
      } finally {
        setLoading(false);
      }
    };

    const fetchAuthStatus = async () => {
      try {
        const aRes = await axios.get('/api/v1/reputation/gmb/auth/status');
        if (aRes.data) {
          setAuthStatus(aRes.data);
        }
      } catch (err) {
        console.warn('GMB Auth status check failed:', err);
      }
    };

    fetchGmbData();
    fetchAuthStatus();
  }, [isOpen, profileId, office]);

  if (!isOpen || !office) return null;

  // 🔴 ГОТОВНОСТЬ РЕШАЕТ СЕРВЕР (quick-260917-23g). Здесь стояла ВТОРАЯ КОПИЯ
  //    правила доступа — `Boolean(authStatus?.connected)`, — и она разошлась с
  //    сервером в первый же день: ручка отдавала `has_gmb_scope: false`,
  //    кнопка включалась, подсказка обещала обращение к Google, а сервер
  //    отказывал «нет разрешения business.manage». Собирать условие здесь
  //    заново (`connected && has_gmb_scope`) ЗАПРЕЩЕНО: это была бы четвёртая
  //    копия того же правила.
  // 🔴 ОТКАЗ В БЕЗОПАСНУЮ СТОРОНУ: сравнение строгое с `true`. Поля нет
  //    (старый бэкенд, ручка ответила иначе, ответ не пришёл) — кнопка
  //    ВЫКЛЮЧЕНА. Незнание не равно разрешению.
  const mozhnoSync = authStatus?.can_sync === true;
  const zapisNePodklyuchena = locationData?.sync_status === 'NOT_CONNECTED';
  const sostoyanieNeizvestno = !locationData;   // ручка не ответила
  const knopkaVyklyuchena = syncing || !mozhnoSync || zapisNePodklyuchena || sostoyanieNeizvestno;

  // 🔴 ПОДСКАЗКИ РАЗДЕЛЕНЫ, ПОТОМУ ЧТО ВЕДУТ К РАЗНЫМ ДЕЙСТВИЯМ ЧЕЛОВЕКА:
  //    «подключить аккаунт» и «переавторизоваться с правами Business Profile» —
  //    разные работы, и одна подсказка на оба случая отправляет человека не туда.
  // 🔴 НАШ ТЕКСТ называет ДЕЙСТВИЕ, сообщение сервера — ПРИЧИНУ. Это не одно и
  //    то же, поэтому сообщение сервера ДОПИСЫВАЕТСЯ дословно, а не подменяет
  //    наш текст и не подменяется им.
  // 🔴 ПОРЯДОК ВЕТОК ЗНАЧИМ: `mozhnoSync` судится ПЕРВЫМ после `syncing`.
  //    Поставив `!connected` раньше, мы получили бы экран, который при
  //    `can_sync: true` и `connected: false` показывает «требуется
  //    подключение» у ВКЛЮЧЁННОЙ кнопки — подсказка противоречила бы кнопке.
  let podskazkaSync;
  if (syncing) {
    podskazkaSync = 'Идёт обращение к ручке: подождите ответа.';
  } else if (!mozhnoSync) {
    let svoy;
    if (!authStatus?.connected) {
      svoy = 'Требуется подключение аккаунта Google';
    } else if (authStatus?.has_gmb_scope === false) {
      svoy = 'Требуется повторная авторизация в Google с правами управления Business Profile';
    } else {
      // Поля `can_sync` нет, а прочие признаки ни о чём не говорят: сервер
      // готовность НЕ ПОДТВЕРДИЛ, и это отдельное состояние мира.
      svoy = 'Сервер не подтвердил готовность к синхронизации: признак can_sync не получен';
    }
    podskazkaSync = authStatus?.message ? `${svoy}. Сервер: ${authStatus.message}` : svoy;
  } else if (sostoyanieNeizvestno) {
    podskazkaSync = 'Состояние записи неизвестно: ручка не ответила, спрашивать нечего.';
  } else if (zapisNePodklyuchena) {
    podskazkaSync = 'Запись не подключена к Google: спрашивать нечего.';
  } else {
    podskazkaSync = 'Спросить Google и обновить отметку синхронизации.';
  }

  // Handler: Manual 24h Sync
  const handleSyncNow = async () => {
    setSyncing(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/sync`);
      const itog = (res && res.data && res.data.result) || {};
      // 🔴 Отметку времени ставит СЕРВЕР. Считать её часами браузера значило
      //    бы завести второго держателя момента, который разойдётся молча.
      const moment = itog.last_synced_at || null;
      setLocationData(prev => (prev ? {
        ...prev,
        last_synced_at: moment,
        sync_status: itog.status || prev.sync_status,
        sync_error: itog.prichina || null,
      } : prev));
      // 🔴 ТОСТ СТРОГО ПО ФАКТУ. Синхронизацией зовётся ТОЛЬКО ответ Google:
      //    здесь стояло «Синхронизация выполнена ручкой» при любом исходе,
      //    включая тот, в котором к Google никто не обращался.
      if (itog.status === 'synced') {
        toast.success('Google ответил: отметка синхронизации обновлена.');
      } else {
        toast.error(`Синхронизации с Google не было: ${itog.prichina || 'причина не названа'}. Ниже показано МЕСТНОЕ состояние записи, а не ответ Google.`);
      }
    } catch (err) {
      // 🔴 Здесь печатался ЗЕЛЁНЫЙ УСПЕХ НА ОТКАЗЕ: «Sync complete. Live
      //    Google metrics verified». Ничего не синхронизировано и ничего не
      //    проверено — отметка времени поэтому НЕ МЕНЯЕТСЯ.
      // 🔴 Тот же род беды, что и в аудите: причина с сервера обязана дойти
      //    до человека, а не подменяться номером кода ответа.
      toast.error(`Синхронизация НЕ выполнена: ${
        (err && err.response && err.response.data && err.response.data.detail)
        || (err && err.message)
        || 'причина не названа'}`);
    } finally {
      setSyncing(false);
    }
  };

  // Handler: Run AI 7-Factor Audit
  const handleRunAudit = async () => {
    setAuditing(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/audit`);
      if (res.data) {
        setLatestAudit(res.data);
        toast.success(`Аудит выполнен. Оценка: ${pokazatVelichinu(res.data.overall_score)}`);
      }
    } catch (err) {
      // 🔴 ПРИЧИНА, НАЗВАННАЯ СЕРВЕРОМ СЛОВАМИ, ОБЯЗАНА ДОЙТИ ДО ЧЕЛОВЕКА
      //    (quick-260917-1bw). Здесь печаталось `err.message`, то есть
      //    «Request failed with status code 502»: сервер называл причину
      //    («ключ модели не задан», «ответ модели не разобран»), а человек
      //    видел номер. Номер не говорит, что чинить.
      const prichina = (err && err.response && err.response.data && err.response.data.detail)
        || (err && err.message)
        || 'причина не названа';
      toast.error(`Аудит НЕ выполнен: ${prichina}`);
    } finally {
      setAuditing(false);
    }
  };

  // Handler: Connect Google OAuth
  const handleConnectGoogle = async () => {
    setConnectingGoogle(true);
    try {
      const res = await axios.get('/api/v1/reputation/gmb/auth/url');
      if (res.data?.authorization_url) {
        window.open(res.data.authorization_url, '_blank');
        toast.success('Google Authorization opened in a new tab. Please approve and return.');
      }
    } catch (err) {
      toast.error('Could not initiate Google connection');
    } finally {
      setConnectingGoogle(false);
    }
  };

  // Helper: Get direct URLs for the active office
  const getOfficeGoogleUrls = () => {
    // 🔴 Ни города, ни имени фирмы по умолчанию: и то и другое приходит из
    //    карточки офиса (канон держателя `app/services/ofisy.py`).
    const cityName = office?.location_name?.split(',')[0] || '';
    const query = encodeURIComponent([office?.company_name, cityName].filter(Boolean).join(' '));
    return {
      searchManageUrl: `https://www.google.com/search?q=${query}`,
      // 🔴 Ссылки на карты по умолчанию нет: адрес чужой записи в Google —
      //    утверждение о мире, и выдумывать его нельзя.
      mapsUrl: office?.gmb_url || null,
      locationsListUrl: 'https://business.google.com/locations'
    };
  };

  // Handler: Copy Post & Open Google Maps Profile
  const handleCopyAndOpenGoogle = (customText) => {
    const textToCopy = customText || postSummary;
    if (!textToCopy.trim()) {
      toast.error('Please generate or enter post content first');
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy);
    }
    const { searchManageUrl } = getOfficeGoogleUrls();
    toast.success('📋 Текст скопирован! Открываем профиль в Google — нажмите "+ Add update" и вставьте текст (Cmd+V).', { duration: 6000 });
    window.open(searchManageUrl, '_blank');
  };

  // Handler: Generate Post with Gemini
  const handleGeneratePost = async (customTopic) => {
    const topicToUse = typeof customTopic === 'string' ? customTopic : postTopic;
    setGeneratingPost(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/posts/generate`, {
        topic: topicToUse || undefined
      });
      if (res.data) {
        if (res.data.topic) {
          setPostTopic(res.data.topic);
        } else if (!topicToUse && res.data.headline) {
          setPostTopic(res.data.headline);
        }
        setPostSummary(res.data.summary || '');
        setPostCtaType(res.data.cta_type || 'BOOK');
        setPostCtaUrl(res.data.cta_url || 'https://fitenkolaw.com/consultation');
        if (res.data.media_url) {
          const matching = availablePhotos.find(p => p.url === res.data.media_url);
          if (matching) {
            setSelectedPhoto(matching);
          } else {
            setSelectedPhoto({
              url: res.data.media_url,
              label: res.data.media_caption || 'Attorney Photo (Media Vault)',
              category: 'portrait',
              filename: 'vault_photo.jpg'
            });
          }
        } else if (availablePhotos.length > 0 && !selectedPhoto) {
          const defaultPhoto = availablePhotos.find(p => p.category === 'portrait' || p.category === 'action') || availablePhotos[0];
          setSelectedPhoto(defaultPhoto);
        }
        toast.success('AI Post Draft generated with Gemini 2.5');
      }
    } catch (err) {
      // 🔴 Здесь на ОТКАЗЕ генератора подставлялся готовый текст поста от
      //    имени фирмы и адвоката — и печаталось «draft prepared», как будто
      //    его написал генератор. Черновик, написанный вёрсткой, публикуется
      //    от имени фирмы так же, как настоящий.
      toast.error(`Черновик НЕ создан: ${(err && err.message) || 'причина не названа'}`);
    } finally {
      setGeneratingPost(false);
    }
  };

  // Handler: Publish Google Post
  const handlePublishPost = async () => {
    if (!postSummary.trim()) {
      toast.error('Post content cannot be empty');
      return;
    }
    setPublishingPost(true);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/posts`, {
        summary: postSummary,
        cta_type: postCtaType,
        cta_url: postCtaUrl,
        media_url: selectedPhoto ? selectedPhoto.url : null,
        ai_topic: postTopic || 'General Immigration Counsel'
      });
      if (res.data?.live_published) {
        toast.success('Google Post published live to Google Maps listing!');
      } else {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(postSummary);
        }
        toast.success('📋 Текст поста скопирован в буфер! Откройте карточку в Google кнопкой ниже и вставьте (Cmd+V).', {
          duration: 7000
        });
      }
      setPosts(prev => [
        {
          id: res.data?.post_id || String(Date.now()),
          summary: postSummary,
          cta_type: postCtaType,
          cta_url: postCtaUrl,
          status: res.data?.live_published ? 'published' : 'published_local',
          published_at: res.data?.live_published ? new Date().toISOString() : null,
          created_at: new Date().toISOString()
        },
        ...prev
      ]);
      setPostSummary('');
    } catch (err) {
      // 🔴 Здесь печаталось «Post saved to listing history» на ОТКАЗЕ записи:
      //    пост никуда не сохранён, а текст из поля ещё и стирался.
      toast.error(`Пост НЕ сохранён: ${(err && err.message) || 'причина не названа'}`);
    } finally {
      setPublishingPost(false);
    }
  };

  // Handler: Mark Post Live on Google Maps
  const handleMarkPostLive = async (postId) => {
    try {
      await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/posts/${postId}/mark-published`);
      toast.success('Пост подтвержден как опубликованный на Google Maps!');
      setPosts(prev =>
        prev.map(p => p.id === postId ? { ...p, status: 'published', published_at: new Date().toISOString() } : p)
      );
    } catch (err) {
      // 🔴 Здесь статус поста менялся на «опубликован» ИМЕННО ТОГДА, когда
      //    ручка отметить его не смогла: экран расходился с базой молча.
      toast.error(`Отметку не удалось сохранить: ${(err && err.message) || 'причина не названа'}`);
    }
  };

  // Handler: Draft AI Review Reply
  const handleDraftReply = async (review) => {
    setReplyingReviewId(review.id);
    try {
      const res = await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/reviews/${review.id}/draft-reply`);
      if (res.data?.suggested_reply) {
        setReplyDrafts(prev => ({ ...prev, [review.id]: res.data.suggested_reply }));
      }
    } catch (err) {
      // 🔴 На отказе генератора здесь подставлялся готовый ответ с подписью
      //    адвоката. Публичный ответ от имени адвоката, написанный вёрсткой, —
      //    утверждение от лица человека, который его не писал.
      toast.error(`Черновик ответа НЕ создан: ${(err && err.message) || 'причина не названа'}`);
    } finally {
      setReplyingReviewId(null);
    }
  };

  // Handler: Submit Review Reply
  const handleSubmitReply = async (review) => {
    const text = replyDrafts[review.id];
    if (!text) return;
    setSubmittingReply(true);
    try {
      await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/reviews/${review.id}/reply`, {
        reply_text: text
      });
      toast.success('Attorney reply published to Google Maps!');
      setReviews(prev =>
        prev.map(r => r.id === review.id ? { ...r, reply_text: text, reply_status: 'published' } : r)
      );
    } catch (err) {
      // 🔴 Здесь ответ помечался опубликованным на отказе публикации: человек
      //    считал, что клиенту ответили, а ответа не было.
      toast.error(`Ответ НЕ опубликован: ${(err && err.message) || 'причина не названа'}`);
    } finally {
      setSubmittingReply(false);
    }
  };

  // Handler: Save Autopilot Settings
  const handleSaveAutopilot = async () => {
    try {
      await axios.post(`/api/v1/reputation/gmb/locations/${profileId}/autopilot`, {
        autopilot_enabled: autopilotEnabled,
        autopilot_weekly_post: autopilotWeeklyPost,
        autopilot_review_auto_reply: autopilotReviewReply,
        post_day: autopilotPostDay
      });
      toast.success('Настройки автопилота сохранены ручкой.');
    } catch (err) {
      toast.error(`Настройки автопилота НЕ сохранены: ${(err && err.message) || 'причина не названа'}`);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs">
      <div className="bg-[#FCFBF8] border border-[#E5E1D6] rounded-2xl w-full max-w-5xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        
        {/* HEADER */}
        <div className="px-6 py-5 border-b border-[#F1EEE4] bg-white flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[#FAF4E5] border border-[#E5D7B5] flex items-center justify-center text-[#C8A653]">
              <MapPin className="w-5 h-5" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h2 className="text-lg font-serif font-bold text-[#20231F]">
                  Google Business Profile Command Center
                </h2>
                <span className="text-[10px] uppercase font-bold px-2 py-0.5 rounded bg-[#FAF4E5] text-[#A97F2E]">
                  {office.badge || (office.is_main ? 'Main Canon' : 'Branch')}
                </span>
              </div>
              <div className="text-xs text-[#687077] flex items-center gap-2 mt-0.5">
                <span>{office.address}</span>
                <span>·</span>
                {/* 🔴 Здесь обе ветки утверждали синхронизацию: «нет отметки
                    времени» печаталось как «live». Теперь печатается САМ
                    момент, а его отсутствие — словами. */}
                <span className="text-[#687077] font-medium flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  {locationData?.last_synced_at
                    ? `Синхронизировано: ${locationData.last_synced_at}`
                    : 'Синхронизации не было'}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              data-knopka="sync"
              onClick={handleSyncNow}
              disabled={knopkaVyklyuchena}
              className="h-8 px-3 inline-flex items-center gap-1.5 text-xs font-semibold rounded-lg bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F8F7F2] transition-colors cursor-pointer shadow-2xs disabled:opacity-50 disabled:cursor-not-allowed"
              title={podskazkaSync}
            >
              <RefreshCw className={`w-3.5 h-3.5 text-[#C8A653] ${syncing ? 'animate-spin' : ''}`} />
              <span>{syncing ? 'Syncing...' : 'Sync Now'}</span>
            </button>

            {office.gmb_url && (
              <a
                href={office.gmb_url}
                target="_blank"
                rel="noopener noreferrer"
                className="h-8 px-3 inline-flex items-center gap-1.5 text-xs font-semibold rounded-lg bg-[#20231F] text-white hover:bg-[#343833] transition-colors cursor-pointer shadow-2xs"
              >
                <ExternalLink className="w-3.5 h-3.5 text-[#C8A653]" />
                <span>Open Maps</span>
              </a>
            )}

            <button
              onClick={onClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-[#687077] hover:text-[#20231F] hover:bg-[#F1EEE4] transition-colors cursor-pointer"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* NAVIGATION TABS */}
        <div className="px-6 py-2 bg-[#F8F7F2] border-b border-[#E5E1D6] flex items-center gap-2 overflow-x-auto text-xs font-medium">
          <button
            onClick={() => setActiveTab('audit')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'audit' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <ShieldCheck className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>AI 7-Factor Audit</span>
            {latestAudit && (
              <span className="text-[10px] font-bold px-1.5 py-0.2 rounded bg-[#C8A653] text-[#20231F]">
                {pokazatVelichinu(latestAudit.score)}/100
              </span>
            )}
          </button>

          <button
            onClick={() => setActiveTab('posts')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'posts' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <Send className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>Google Posts Auto-Pilot</span>
          </button>

          <button
            onClick={() => setActiveTab('reviews')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'reviews' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <MessageSquare className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>Reviews & AI Replies</span>
            <span className="text-[10px] font-bold px-1.5 py-0.2 rounded bg-[#FAF4E5] text-[#A97F2E]">
              {reviews.length}
            </span>
          </button>

          <button
            onClick={() => setActiveTab('services')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'services' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <Briefcase className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>Services Catalog</span>
          </button>

          <button
            onClick={() => setActiveTab('autopilot')}
            className={`px-3.5 py-1.5 rounded-lg flex items-center gap-1.5 transition-colors cursor-pointer ${
              activeTab === 'autopilot' ? 'bg-[#20231F] text-white font-semibold shadow-xs' : 'text-[#687077] hover:text-[#20231F]'
            }`}
          >
            <Sliders className="w-3.5 h-3.5 text-[#C8A653]" />
            <span>24h Auto-Pilot Settings</span>
          </button>
        </div>

        {/* MODAL BODY */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6">

          {/* СОСТОЯНИЕ ЗАПИСИ И ПОКАЗАТЕЛИ — ВИДНЫ НА ЛЮБОЙ ВКЛАДКЕ */}
          <PlashkaSostoyaniya otkazZagruzki={otkazZagruzki} location={locationData} />

          <div className="bg-white border border-[#E5E1D6] rounded-2xl p-5 shadow-xs">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-serif font-bold text-[#20231F]">Показатели Google за 30 дней</h3>
              <span className="text-[10px] text-[#687077]">
                источник — ответ ручки; прочерк означает «замера не было»
              </span>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {POKAZATELI.map(([kluch, podpis]) => (
                <div key={kluch} className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                  <div className="text-[10px] uppercase font-bold text-[#687077]">{podpis}</div>
                  <div
                    data-metrika={kluch}
                    className="text-lg font-serif font-bold text-[#20231F] mt-0.5"
                  >
                    {pokazatVelichinu(locationData ? locationData[kluch] : null)}
                  </div>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-3">
              <div className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                <div className="text-[10px] uppercase font-bold text-[#687077]">Рейтинг</div>
                <div data-metrika="rating" className="text-lg font-serif font-bold text-[#20231F] mt-0.5">
                  {pokazatVelichinu(locationData ? locationData.rating : null)}
                </div>
              </div>
              <div className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                <div className="text-[10px] uppercase font-bold text-[#687077]">Отзывов</div>
                <div data-metrika="reviews_count" className="text-lg font-serif font-bold text-[#20231F] mt-0.5">
                  {pokazatVelichinu(locationData ? locationData.reviews_count : null)}
                </div>
              </div>
              <div className="p-3 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8]">
                <div className="text-[10px] uppercase font-bold text-[#687077]">Оценка аудита</div>
                <div data-metrika="latest_audit_score" className="text-lg font-serif font-bold text-[#20231F] mt-0.5">
                  {pokazatVelichinu(locationData ? locationData.latest_audit_score : null)}
                </div>
              </div>
            </div>
          </div>

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 1: AI 7-FACTOR AUDIT                                      */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'audit' && (
            <div className="space-y-6">
              {/* Score banner */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 flex flex-col md:flex-row md:items-center justify-between gap-6 shadow-xs">
                <div className="flex items-center gap-5">
                  <div className="flex flex-col items-center gap-1">
                    <div className="w-20 h-20 rounded-2xl bg-[#FCFBF8] border-2 border-[#C8A653] flex flex-col items-center justify-center text-center shadow-xs">
                      <span className="text-3xl font-serif font-bold text-[#20231F]">
                        {pokazatVelichinu(latestAudit?.score)}
                      </span>
                      {/* 🔴 «Grade —» печаталось и тогда, когда аудита не было
                          вовсе: подпись под прочерком выглядит как разряд, в
                          который запись попала. Нет записи — нет и грейда. */}
                      <span className="text-[10px] uppercase font-bold text-[#A97F2E]">
                        {latestAudit ? `Grade ${pokazatVelichinu(latestAudit.grade)}` : 'замера нет'}
                      </span>
                    </div>
                    {/* 🔴 МОМЕНТ ЗАМЕРА РЯДОМ С ЧИСЛОМ (quick-260917-1bw). Число
                        без времени читается как сегодняшнее: оценка годичной
                        давности выглядит на экране так же, как снятая минуту
                        назад. Нет записи — ничего не печатается (рядом уже
                        стоит «Аудит не проводился: сводки нет»); есть запись
                        без момента — так и сказано, а не подставлено «сейчас».
                        🔴 Момент печатается ДОСЛОВНО, как его назвал сервер, и
                        НЕ пересчитывается в «N дней назад»: относительный срок
                        лжёт в момент чтения, а пересчёт без часового пояса был
                        бы новым утверждением о времени. */}
                    {latestAudit && (
                      <span data-audit="moment" className="text-[10px] text-[#687077] text-center leading-tight max-w-[7rem]">
                        {latestAudit.izmereno_v
                          ? `Замер: ${latestAudit.izmereno_v}`
                          : 'Момент замера неизвестен'}
                      </span>
                    )}
                  </div>
                  <div>
                    {/* 🔴 Подпись о модели печаталась ВСЕГДА, в том числе когда
                        модель не спрашивали ни разу. «Аудит сделан Gemini 2.5» —
                        такое же утверждение о мире, как и число, и без записи
                        оно ложно. Печатается то, что ЗАПИСАНО в строке журнала,
                        а не литерал в вёрстке. */}
                    {latestAudit && (
                      <div data-audit="model" className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[10px] font-bold bg-[#FAF4E5] text-[#A97F2E] mb-1">
                        <Sparkles className="w-3 h-3 text-[#C8A653]" />
                        <span>Аудит моделью: {latestAudit.model_used || 'модель не названа'}</span>
                      </div>
                    )}
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      Listing Optimization Health Score
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5 max-w-lg leading-relaxed">
                      {/* 🔴 Здесь стоял готовый вывод аудита — с именем адвоката и
                          номером Bar — который печатался, КОГДА АУДИТА НЕ БЫЛО. */}
                      {latestAudit?.summary || 'Аудит не проводился: сводки нет.'}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={handleRunAudit}
                    disabled={auditing}
                    className="h-9 px-4 rounded-xl text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] inline-flex items-center gap-2 transition-colors cursor-pointer shadow-xs"
                  >
                    <RefreshCw className={`w-3.5 h-3.5 text-[#C8A653] ${auditing ? 'animate-spin' : ''}`} />
                    <span>{auditing ? 'Auditing with AI...' : 'Re-Run Deep Audit'}</span>
                  </button>
                </div>
              </div>

              {/* 7 Factors Breakdown */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                <h3 className="text-sm font-serif font-bold text-[#20231F] mb-4">
                  7 Core Local Ranking Factors
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {[
                    /* 🔴 УМОЛЧАНИЙ НЕТ. Здесь стояли семь правдоподобных процентов и
                       подписи, УТВЕРЖДАВШИЕ проверку («matched 100%», «verified logo
                       present»), которой никто не делал. Фактор не измерен — прочерк. */
                    { label: 'NAP & Bar Consistency', score: latestAudit?.factors?.nap_consistency, desc: 'Согласие адреса, телефона и реестровой записи' },
                    { label: 'Primary Categories', score: latestAudit?.factors?.categories, desc: 'Основная и дополнительные категории записи' },
                    { label: 'Services Catalog', score: latestAudit?.factors?.services_catalog, desc: 'Заполненность каталога услуг' },
                    { label: 'Visual Media & Photos', score: latestAudit?.factors?.visual_media, desc: 'Фотографии записи' },
                    { label: 'Google Posts Cadence', score: latestAudit?.factors?.posts_cadence, desc: 'Регулярность публикаций' },
                    { label: 'Review Velocity & Sentiment', score: latestAudit?.factors?.review_velocity, desc: 'Скорость набора отзывов и ответы на них' },
                    { label: 'Local Geo Prominence', score: latestAudit?.factors?.local_prominence, desc: 'Заметность записи в локальной выдаче' }
                  ].map((f, i) => (
                    <div key={i} className="p-4 rounded-xl border border-[#F1EEE4] bg-[#FCFBF8] space-y-2">
                      <div className="flex items-center justify-between">
                        <span className="text-xs font-bold text-[#20231F]">{f.label}</span>
                        <span className="text-xs font-serif font-bold text-[#0B8B5E]">
                          {f.score === null || f.score === undefined ? '—' : `${f.score}%`}
                        </span>
                      </div>
                      {/* Полоса рисуется ТОЛЬКО по измеренной величине: полоса
                          нулевой длины на месте «не измерено» читалась бы как ноль. */}
                      {f.score === null || f.score === undefined ? null : (
                        <div className="w-full h-1.5 bg-[#F1EEE4] rounded-full overflow-hidden">
                          <div
                            className={`h-full rounded-full ${f.score >= 90 ? 'bg-[#0B8B5E]' : 'bg-[#C8A653]'}`}
                            style={{ width: `${f.score}%` }}
                          />
                        </div>
                      )}
                      <p className="text-[11px] text-[#687077] leading-tight">{f.desc}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Actionable Fixes */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <h3 className="text-sm font-serif font-bold text-[#20231F]">
                  Actionable AI Improvements & Gaps
                </h3>

                <div className="space-y-3">
                  {(latestAudit?.gaps || []).map((gap, i) => (
                    <div key={i} className="p-3.5 rounded-xl bg-[#FCFBF8] border border-[#F1EEE4] flex items-start gap-3 text-xs">
                      <AlertTriangle className="w-4 h-4 text-[#C8A653] shrink-0 mt-0.5" />
                      <span className="text-[#20231F] flex-1 leading-relaxed">{gap}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 2: GOOGLE POSTS (AUTO-PILOT & GENERATOR)                  */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'posts' && (
            <div className="space-y-6">
              {/* Google OAuth & GBP Direct API Status Banner */}
              <div className={`p-4 rounded-xl border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 ${
                authStatus.has_gmb_scope
                  ? 'bg-[#E6F6EE] border-[#B7E5D0] text-[#0B8B5E]'
                  : 'bg-[#FAF4E5] border-[#E5D7B5] text-[#20231F]'
              }`}>
                <div className="flex items-center gap-2.5">
                  <Bot className={`w-4 h-4 shrink-0 ${authStatus.has_gmb_scope ? 'text-[#0B8B5E]' : 'text-[#C8A653]'}`} />
                  <div className="text-xs leading-relaxed">
                    <span className="font-bold">
                      {authStatus.has_gmb_scope
                        ? 'Google Business Profile API: Connected & Authorized'
                        : 'Google Business Profile API: Connection Status'}
                    </span>
                    <p className="text-[11px] text-[#687077] mt-0.5">
                      {authStatus.has_gmb_scope
                        ? `Authorized for ${authStatus.email || 'fitenkolaw@gmail.com'}. Posts publish directly live to Google Maps.`
                        : `Link fitenkolaw@gmail.com with Business Profile scope to enable direct 1-click live publishing, or use 📋 Copy & Open below.`}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-2 shrink-0">
                  {!authStatus.has_gmb_scope && (
                    <button
                      type="button"
                      onClick={handleConnectGoogle}
                      disabled={connectingGoogle}
                      className="h-8 px-3.5 rounded-lg text-xs font-semibold bg-[#20231F] text-[#C8A653] border border-[#C8A653]/30 hover:bg-[#343833] inline-flex items-center gap-1.5 transition-colors cursor-pointer shadow-xs"
                    >
                      <ExternalLink className="w-3.5 h-3.5 text-[#C8A653]" />
                      <span>{connectingGoogle ? 'Подключение...' : '🔑 Подключить авто-публикацию в Google'}</span>
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={() => window.open(getOfficeGoogleUrls().searchManageUrl, '_blank')}
                    className="h-8 px-3 rounded-lg text-xs font-semibold bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F9F7F1] inline-flex items-center gap-1.5 transition-colors cursor-pointer"
                    title="Open Google Profile directly in Google Search"
                  >
                    <ExternalLink className="w-3.5 h-3.5 text-[#687077]" />
                    <span>Открыть профиль в Google</span>
                  </button>
                </div>
              </div>

              {/* Post Creator Box */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <div className="flex items-center justify-between pb-3 border-b border-[#F1EEE4]">
                  <div>
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      Create & Publish Google Local Post
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5">
                      Published directly to Google Maps under {office.company_name} in {office.location_name?.split(',')[0]}.
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleGeneratePost()}
                    disabled={generatingPost}
                    className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1.5 transition-colors cursor-pointer"
                  >
                    <Sparkles className={`w-3.5 h-3.5 text-[#C8A653] ${generatingPost ? 'animate-spin' : ''}`} />
                    <span>{generatingPost ? 'Generating...' : '✨ Generate with Gemini'}</span>
                  </button>
                </div>

                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-[#20231F] mb-1">
                      Legal Topic or News Trigger (Optional)
                    </label>
                    <input
                      type="text"
                      value={postTopic}
                      onChange={e => setPostTopic(e.target.value)}
                      placeholder="e.g., USCIS Visa Bulletin Analysis, EB-1 Criteria, Asylum Consultations"
                      className="w-full h-9 px-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                    />

                    {/* Quick-Pick Suggested Topics */}
                    <div className="flex flex-wrap items-center gap-1.5 pt-2">
                      <span className="text-[11px] font-medium text-[#687077]">Suggested:</span>
                      {[
                        'USCIS Visa Bulletin & Priority Dates',
                        'EB-1A Extraordinary Ability Strategy',
                        'EB-2 NIW for STEM & AI Founders',
                        'Affirmative Asylum & Work Authorization',
                        'Family Green Card & Concurrent Filing'
                      ].map((suggested, sIdx) => (
                        <button
                          key={sIdx}
                          type="button"
                          onClick={() => {
                            setPostTopic(suggested);
                            handleGeneratePost(suggested);
                          }}
                          className="text-[10px] px-2 py-0.5 rounded-md bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] transition-colors cursor-pointer"
                        >
                          ⚡ {suggested}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-semibold text-[#20231F] mb-1">
                      Post Content (up to 1,500 characters)
                    </label>
                    <textarea
                      rows={5}
                      value={postSummary}
                      onChange={e => setPostSummary(e.target.value)}
                      placeholder="Enter post text or click 'Generate with Gemini' above..."
                      className="w-full p-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                    />
                  </div>

                  {/* ───────────────────────────────────────────────────────────── */}
                  {/* ATTORNEY PHOTO VAULT / MEDIA PICKER                          */}
                  {/* ───────────────────────────────────────────────────────────── */}
                  <div className="pt-1">
                    <div className="flex items-center justify-between mb-2">
                      <label className="flex items-center gap-1.5 text-xs font-semibold text-[#20231F]">
                        <Camera className="w-3.5 h-3.5 text-[#C8A653]" />
                        <span>Attached Attorney / Office Photo (Google Maps Post Media)</span>
                      </label>
                      <div className="flex items-center gap-2">
                        <label className="h-7 px-2.5 rounded-lg text-xs font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1 cursor-pointer transition-colors shadow-2xs">
                          <Upload className="w-3 h-3 text-[#C8A653]" />
                          <span>{uploadingPhotos ? 'Загрузка...' : '+ Загрузить пачку фото (до 50)'}</span>
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleBulkUploadPhotos}
                            className="hidden"
                            disabled={uploadingPhotos}
                          />
                        </label>
                        <button
                          type="button"
                          onClick={() => setShowPhotoVault(!showPhotoVault)}
                          className="text-xs font-semibold text-[#C8A653] hover:underline cursor-pointer"
                        >
                          {showPhotoVault ? 'Свернуть галерею' : `Выбрать из галереи (${availablePhotos.length})`}
                        </button>
                      </div>
                    </div>

                    {/* Active Selected Photo Preview Banner */}
                    {selectedPhoto ? (
                      <div className="flex items-center justify-between p-3 rounded-xl border border-[#E5E1D6] bg-[#FCFBF8]">
                        <div className="flex items-center gap-3">
                          <img
                            src={selectedPhoto.url}
                            alt={selectedPhoto.label}
                            className="w-14 h-14 object-cover rounded-lg border border-[#E5E1D6] shadow-2xs"
                          />
                          <div>
                            <div className="text-xs font-bold text-[#20231F] flex items-center gap-1.5">
                              <span>{selectedPhoto.label}</span>
                              <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded bg-[#FAF4E5] text-[#A97F2E] uppercase">
                                {selectedPhoto.category}
                              </span>
                            </div>
                            <p className="text-[11px] text-[#687077] truncate max-w-sm mt-0.5">
                              {selectedPhoto.filename}
                            </p>
                            <span className="text-[10px] text-[#0B8B5E] font-medium inline-flex items-center gap-1 mt-0.5">
                              <CheckCircle2 className="w-2.5 h-2.5" />
                              Будет прикреплено к посту в Google Maps
                            </span>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => {
                              const randomIdx = Math.floor(Math.random() * availablePhotos.length);
                              setSelectedPhoto(availablePhotos[randomIdx]);
                              toast.success('Выбрано случайное фото адвоката!');
                            }}
                            className="h-7 px-2 text-[11px] font-medium text-[#687077] hover:text-[#20231F] border border-[#E5E1D6] rounded-lg hover:bg-white"
                          >
                            🎲 Случайное
                          </button>
                          <button
                            type="button"
                            onClick={() => setSelectedPhoto(null)}
                            className="h-7 px-2 text-[11px] font-medium text-[#C93B2B] hover:bg-[#FDF2F2] rounded-lg border border-[#FAD2CF]"
                          >
                            Убрать фото
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="p-3 text-center border border-dashed border-[#D3CEBF] rounded-xl bg-[#FAF9F5]">
                        <p className="text-xs text-[#687077]">
                          Фото не прикреплено. Нажмите <button type="button" onClick={() => setShowPhotoVault(true)} className="text-[#C8A653] font-semibold underline">выбрать из галереи</button> или загрузите новые фото адвоката.
                        </p>
                      </div>
                    )}

                    {/* Expandable Gallery Grid */}
                    {showPhotoVault && (
                      <div className="mt-3 p-4 rounded-xl border border-[#E5D7B5] bg-[#FFFDF9] space-y-3 shadow-xs">
                        <div className="flex flex-wrap items-center justify-between gap-2 border-b border-[#F1E8D2] pb-2.5">
                          <div className="flex items-center gap-1.5 text-xs font-semibold text-[#20231F]">
                            <ImageIcon className="w-3.5 h-3.5 text-[#C8A653]" />
                            <span>Медиа-библиотека адвоката ({availablePhotos.length} фото)</span>
                          </div>
                          <div className="flex items-center gap-1 text-[11px]">
                            {['all', 'portrait', 'action', 'credentials', 'office'].map((cat) => (
                              <button
                                key={cat}
                                type="button"
                                onClick={() => setPhotoCategory(cat)}
                                className={`px-2 py-0.5 rounded-md font-medium capitalize cursor-pointer transition-colors ${
                                  photoCategory === cat
                                    ? 'bg-[#20231F] text-white'
                                    : 'bg-white text-[#687077] border border-[#E5E1D6] hover:text-[#20231F]'
                                }`}
                              >
                                {cat === 'all' ? 'Все' : cat}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-2.5 max-h-56 overflow-y-auto pr-1">
                          {availablePhotos
                            .filter(p => photoCategory === 'all' || p.category === photoCategory)
                            .map((photo, idx) => {
                              const isSelected = selectedPhoto?.filename === photo.filename;
                              return (
                                <div
                                  key={idx}
                                  onClick={() => setSelectedPhoto(photo)}
                                  className={`group relative rounded-lg overflow-hidden border-2 cursor-pointer transition-all aspect-square bg-gray-100 ${
                                    isSelected
                                      ? 'border-[#C8A653] ring-2 ring-[#C8A653]/30 scale-95'
                                      : 'border-transparent hover:border-[#D3CEBF]'
                                  }`}
                                >
                                  <img
                                    src={photo.url}
                                    alt={photo.label}
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                                  />
                                  {isSelected && (
                                    <div className="absolute top-1 right-1 bg-[#C8A653] text-white p-0.5 rounded-full shadow-xs">
                                      <Check className="w-3 h-3" />
                                    </div>
                                  )}
                                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-1">
                                    <p className="text-[9px] text-white font-medium truncate">
                                      {photo.label}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">
                    <div>
                      <label className="block text-xs font-semibold text-[#20231F] mb-1">
                        Call-to-Action Button
                      </label>
                      <select
                        value={postCtaType}
                        onChange={e => setPostCtaType(e.target.value)}
                        className="w-full h-9 px-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                      >
                        <option value="BOOK">Book Appointment</option>
                        {/* 🔴 Номер телефона фирмы в вёрстке был ТРЕТЬЕЙ копией канона.
                            Номер берёт Google из самой записи. */}
                        <option value="CALL">Call Now</option>
                        <option value="LEARN_MORE">Learn More</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-semibold text-[#20231F] mb-1">
                        CTA Destination URL
                      </label>
                      <input
                        type="text"
                        value={postCtaUrl}
                        onChange={e => setPostCtaUrl(e.target.value)}
                        className="w-full h-9 px-3 text-xs rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] text-[#20231F] focus:outline-hidden focus:border-[#C8A653]"
                      />
                    </div>
                  </div>

                  <div className="flex flex-wrap items-center justify-between gap-3 pt-3 border-t border-[#F1EEE4]">
                    <button
                      type="button"
                      onClick={() => handleCopyAndOpenGoogle()}
                      disabled={!postSummary.trim()}
                      className="h-9 px-4 rounded-xl text-xs font-semibold bg-white border border-[#E5E1D6] text-[#20231F] hover:bg-[#F9F7F1] disabled:opacity-50 inline-flex items-center gap-2 transition-colors cursor-pointer shadow-xs"
                      title="Скопировать текст и открыть карточку офиса в Google"
                    >
                      <Copy className="w-3.5 h-3.5 text-[#C8A653]" />
                      <span>📋 Скопировать и открыть в Google</span>
                    </button>

                    <button
                      type="button"
                      onClick={handlePublishPost}
                      disabled={publishingPost || !postSummary.trim()}
                      className="h-9 px-5 rounded-xl text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] disabled:opacity-50 inline-flex items-center gap-2 transition-colors cursor-pointer shadow-xs"
                    >
                      <Send className="w-3.5 h-3.5 text-[#C8A653]" />
                      <span>{publishingPost ? 'Publishing...' : 'Publish to Google Maps'}</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* History of Posts */}
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <h3 className="text-sm font-serif font-bold text-[#20231F]">
                  Recent Google Posts ({posts.length})
                </h3>

                <div className="divide-y divide-[#F1EEE4]">
                  {posts.map((post, idx) => {
                    const isLive = post.status === 'published';
                    return (
                      <div key={idx} className="py-4 space-y-2.5">
                        <div className="flex flex-wrap items-center justify-between gap-2 text-xs">
                          <span className="font-semibold text-[#20231F]">
                            {post.cta_type} · {new Date(post.created_at).toLocaleDateString()}
                          </span>
                          {isLive ? (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded bg-[#E6F6EE] text-[#0B8B5E] border border-[#B7E5D0]">
                              <CheckCircle2 className="w-3 h-3" />
                              <span>LIVE ON GOOGLE MAPS</span>
                            </span>
                          ) : (
                            <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded bg-[#FFF4E5] text-[#B76E00] border border-[#FFE2B2]">
                              <AlertTriangle className="w-3 h-3 text-[#B76E00]" />
                              <span>NOT ON GOOGLE MAPS (SAVED IN OS)</span>
                            </span>
                          )}
                        </div>
                        <p className="text-xs text-[#687077] leading-relaxed">{post.summary}</p>
                        
                        {!isLive && (
                          <div className="flex flex-wrap items-center justify-between gap-2 pt-2 border-t border-[#F8F6F0]">
                            <span className="text-[11px] text-[#A97F2E]">
                              ⚠️ Сохранено в OS. Нажмите, чтобы скопировать и вставить в Google:
                            </span>
                            <div className="flex items-center gap-2">
                              {!authStatus.has_gmb_scope && (
                                <button
                                  type="button"
                                  onClick={handleConnectGoogle}
                                  disabled={connectingGoogle}
                                  className="h-7 px-2.5 rounded-lg text-[11px] font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1 transition-colors cursor-pointer"
                                  title="Авторизовать Google для прямой публикации"
                                >
                                  <Bot className="w-3 h-3 text-[#C8A653]" />
                                  <span>🔑 Авто-публикация</span>
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={() => handleCopyAndOpenGoogle(post.summary)}
                                className="h-7 px-3 rounded-lg text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] inline-flex items-center gap-1.5 transition-colors cursor-pointer shadow-xs"
                              >
                                <Copy className="w-3 h-3 text-[#C8A653]" />
                                <span>📋 Скопировать и открыть в Google</span>
                              </button>
                              <button
                                type="button"
                                onClick={() => handleMarkPostLive(post.id)}
                                className="h-7 px-2.5 rounded-lg text-xs font-semibold bg-white border border-[#B7E5D0] text-[#0B8B5E] hover:bg-[#E6F6EE] inline-flex items-center gap-1 transition-colors cursor-pointer shadow-2xs"
                                title="Подтвердить, что пост опубликован на Картах"
                              >
                                <CheckCircle2 className="w-3 h-3 text-[#0B8B5E]" />
                                <span>✓ Опубликовано</span>
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {posts.length === 0 && (
                    <div className="py-8 text-center text-xs text-[#687077]">
                      No local posts recorded yet. Click 'Generate with Gemini' to draft your first weekly post.
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 3: REVIEWS & AI REPLIES                                   */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'reviews' && (
            <div className="space-y-6">
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs">
                <div className="flex items-center justify-between pb-4 border-b border-[#F1EEE4] mb-4">
                  <div>
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      Google Maps Reviews ({reviews.length})
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5">
                      {/* 🔴 Утверждение «все ответы подписаны …» было ложным по
                          построению: подпись ставится только если её передали. */}
                      Подпись под ответом ставится только та, которую передал человек.
                    </p>
                  </div>
                  <span className="text-xs font-semibold text-[#0B8B5E] bg-[#E6F6EE] px-2.5 py-1 rounded-md">
                    100% Response Coverage
                  </span>
                </div>

                <div className="space-y-4">
                  {reviews.map((rev) => (
                    <div key={rev.id} className="p-5 rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] space-y-3">
                      <div className="flex items-start justify-between">
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="text-xs font-bold text-[#20231F]">{rev.reviewer_name}</span>
                            <span className="text-xs text-[#C8A653] font-bold">
                              {'★'.repeat(rev.star_rating)}
                            </span>
                          </div>
                          <span className="text-[10px] text-[#687077]">
                            {new Date(rev.review_date).toLocaleDateString()}
                          </span>
                        </div>
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded ${
                          rev.reply_text ? 'bg-[#E6F6EE] text-[#0B8B5E]' : 'bg-[#FAF4E5] text-[#A97F2E]'
                        }`}>
                          {rev.reply_text ? 'Replied' : 'Pending Response'}
                        </span>
                      </div>

                      <p className="text-xs text-[#20231F] leading-relaxed italic">
                        "{rev.comment}"
                      </p>

                      {/* Official Reply Box */}
                      {rev.reply_text ? (
                        <div className="p-3.5 rounded-xl bg-white border border-[#E5E1D6] text-xs space-y-1">
                          <div className="font-semibold text-[#C8A653] flex items-center gap-1.5">
                            <Check className="w-3.5 h-3.5 text-[#0B8B5E]" />
                            <span>Официальный ответ{rev.reply_signed_by ? ` — ${rev.reply_signed_by}` : ''}</span>
                          </div>
                          <p className="text-[#687077] leading-relaxed">{rev.reply_text}</p>
                        </div>
                      ) : (
                        <div className="pt-2 border-t border-[#F1EEE4] space-y-2">
                          {replyDrafts[rev.id] ? (
                            <div className="space-y-2">
                              <textarea
                                rows={3}
                                value={replyDrafts[rev.id]}
                                onChange={e => setReplyDrafts({ ...replyDrafts, [rev.id]: e.target.value })}
                                className="w-full p-2.5 text-xs rounded-xl border border-[#E5E1D6] bg-white text-[#20231F]"
                              />
                              <div className="flex justify-end gap-2">
                                <button
                                  onClick={() => handleSubmitReply(rev)}
                                  disabled={submittingReply}
                                  className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] cursor-pointer"
                                >
                                  Publish Reply to Google
                                </button>
                              </div>
                            </div>
                          ) : (
                            <button
                              onClick={() => handleDraftReply(rev)}
                              disabled={replyingReviewId === rev.id}
                              className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#FAF4E5] text-[#A97F2E] border border-[#E5D7B5] hover:bg-[#F3E7C9] inline-flex items-center gap-1.5 transition-colors cursor-pointer"
                            >
                              <Sparkles className="w-3.5 h-3.5 text-[#C8A653]" />
                              <span>{replyingReviewId === rev.id ? 'Drafting...' : '✨ Draft Attorney AI Reply'}</span>
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                  {reviews.length === 0 && (
                    <div className="py-8 text-center text-xs text-[#687077]">
                      This location currently has no Google reviews recorded. New reviews will be automatically ingested every 24 hours.
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 4: SERVICES CATALOG                                       */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'services' && (
            <div className="space-y-6">
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-4">
                <div className="flex items-center justify-between pb-4 border-b border-[#F1EEE4]">
                  <div>
                    <h3 className="text-base font-serif font-bold text-[#20231F]">
                      Google Maps Services Catalog
                    </h3>
                    <p className="text-xs text-[#687077] mt-0.5">
                      Canonical immigration practices published on this Google Business Profile listing.
                    </p>
                  </div>
                  {/* 🔴 Эта кнопка НЕ ХОДИЛА НИКУДА: она печатала «услуги
                      синхронизированы», не сделав ни одного запроса. Сообщение
                      об исходе, написанное до исхода, — не сообщение. */}
                  <button
                    onClick={() => toast('Отсюда услуги в Google не отправляются: ручки выгрузки каталога у этого экрана нет.', { icon: 'ℹ️' })}
                    className="h-8 px-3 rounded-lg text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] inline-flex items-center gap-1.5 cursor-pointer shadow-2xs"
                  >
                    <CheckCircle2 className="w-3.5 h-3.5 text-[#C8A653]" />
                    <span>Push Services to GMB</span>
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3.5">
                  {(locationData?.services || []).map((serv, idx) => (
                    <div key={idx} className="p-4 rounded-xl border border-[#E5E1D6] bg-[#FCFBF8] flex items-start justify-between">
                      <div>
                        <div className="text-xs font-bold text-[#20231F]">{serv.name}</div>
                        <div className="text-[11px] text-[#687077] mt-0.5">{serv.category || 'Immigration Practice'}</div>
                      </div>
                      <span className="text-[10px] font-bold px-2 py-0.5 rounded bg-[#FAF4E5] text-[#A97F2E]">
                        {serv.price || 'Verified'}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* ───────────────────────────────────────────────────────────── */}
          {/* TAB 5: AUTOPILOT SETTINGS                                     */}
          {/* ───────────────────────────────────────────────────────────── */}
          {activeTab === 'autopilot' && (
            <div className="space-y-6">
              <div className="bg-white border border-[#E5E1D6] rounded-2xl p-6 shadow-xs space-y-6">
                <div>
                  <h3 className="text-base font-serif font-bold text-[#20231F]">
                    24-Hour Autonomous GMB Settings
                  </h3>
                  <p className="text-xs text-[#687077] mt-0.5">
                    Configure Celery Beat background automation, weekly posting, and review reply bots.
                  </p>
                </div>

                <div className="space-y-4 divide-y divide-[#F1EEE4]">
                  <div className="pt-4 flex items-center justify-between">
                    <div>
                      <div className="text-xs font-bold text-[#20231F]">24-Hour Full Background Sync</div>
                      <div className="text-[11px] text-[#687077]">Pulls new reviews, updates rating averages, and runs 7-factor audit every night at 03:00 UTC.</div>
                    </div>
                    <input
                      type="checkbox"
                      checked={autopilotEnabled}
                      onChange={e => setAutopilotEnabled(e.target.checked)}
                      className="w-4 h-4 accent-[#C8A653] cursor-pointer"
                    />
                  </div>

                  <div className="pt-4 flex items-center justify-between">
                    <div>
                      <div className="text-xs font-bold text-[#20231F]">Weekly Google Posts Auto-Pilot</div>
                      <div className="text-[11px] text-[#687077]">Generates and publishes weekly immigration news and consultation calls if no post was made in 7 days.</div>
                    </div>
                    <div className="flex items-center gap-3">
                      <select
                        value={autopilotPostDay}
                        onChange={e => setAutopilotPostDay(e.target.value)}
                        className="h-8 px-2 text-xs rounded-lg border border-[#E5E1D6] bg-[#FCFBF8]"
                      >
                        <option value="Monday">Monday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Friday">Friday</option>
                      </select>
                      <input
                        type="checkbox"
                        checked={autopilotWeeklyPost}
                        onChange={e => setAutopilotWeeklyPost(e.target.checked)}
                        className="w-4 h-4 accent-[#C8A653] cursor-pointer"
                      />
                    </div>
                  </div>

                  <div className="pt-4 flex items-center justify-between">
                    <div>
                      <div className="text-xs font-bold text-[#20231F]">Auto-Reply to 5-Star Reviews</div>
                      <div className="text-[11px] text-[#687077]">Automatically publishes personalized, warm attorney responses to all incoming 5★ reviews.</div>
                    </div>
                    <input
                      type="checkbox"
                      checked={autopilotReviewReply}
                      onChange={e => setAutopilotReviewReply(e.target.checked)}
                      className="w-4 h-4 accent-[#C8A653] cursor-pointer"
                    />
                  </div>
                </div>

                <div className="pt-4 border-t border-[#F1EEE4] flex justify-end">
                  <button
                    onClick={handleSaveAutopilot}
                    className="h-9 px-5 rounded-xl text-xs font-semibold bg-[#20231F] text-white hover:bg-[#343833] inline-flex items-center gap-2 cursor-pointer shadow-xs"
                  >
                    <Check className="w-3.5 h-3.5 text-[#C8A653]" />
                    <span>Save Auto-Pilot Configuration</span>
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>

      </div>
    </div>
  );
};

export default GmbCommandModal;
